module.exports = __webpack_public_path__ + "static/assets/c43622e69ed5cf70575aba04b2c90b9a.png";